import React from 'react'
import TextInput from '@mui/material/TextField'
import { makeStyles } from '@mui/styles'
import MaskedInput from 'react-text-mask'

const useStyles = makeStyles(() => ({
  labelRoot: {
    whiteSpace: 'nowrap'
  }
}))

const TextMaskCustom = React.forwardRef(function TextMaskCustom (props, ref) {
  const { mask, ...other } = props

  return (
    <MaskedInput
      {...other}
      ref={(maskedRef) => {
        const inputElement = maskedRef ? maskedRef.inputElement : null
        if (typeof ref === 'function') {
          ref(inputElement)
        } else if (ref) {
          ref.current = inputElement
        }
      }}
      mask={mask}
      placeholderChar={'\u2000'}
      showMask={false}
      guide={false}
    />
  )
})

/**
 * Material-UI Text field for buyflows
 */
const MuiTextField = (props) => {
  const classes = useStyles()
  const {
    input,
    mask,
    hintText,
    meta: { touched, error },
    ...custom
  } = props
  const hasError = touched && error

  const parseMask = mask => {
    if (Array.isArray(mask)) {
      return mask.map(v => {
        const mightBeRegExp = typeof v === 'string' && v.length > 2
        const [, pattern] = mightBeRegExp ? v.match(/\/(.+?)\//) : []
        if (pattern) {
          return new RegExp(pattern)
        }
        return v
      })
    }
    return mask
  }

  return Array.isArray(mask) ? (
    <TextInput
      variant='filled'
      fullWidth
      multiline={!!props.rows}
      helperText={hasError ? error : hintText}
      error={hasError}
      className='text-field'
      id={input.name}
      InputProps={{
        disableUnderline: true,
        inputComponent: TextMaskCustom,
        inputProps: {
          mask: parseMask(mask),
          style: !props.rows ? { height: '100%' } : undefined
        }
      }}
      InputLabelProps={{
        classes: {
          root: classes.labelRoot
        }
      }}
      {...input}
      {...custom}
    />
  ) : (
    <TextInput
      variant='filled'
      fullWidth
      multiline={!!props.rows}
      helperText={hasError ? error : hintText}
      error={hasError}
      className='text-field'
      id={input.name}
      InputLabelProps={{
        classes: {
          root: classes.labelRoot
        }
      }}
      InputProps={{
        disableUnderline: true,
        inputProps: !props.rows ? { style: { height: '100%' } } : undefined
      }}
      {...input}
      {...custom}
    />
  )
}

export default MuiTextField
